import { FC } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';

type ConfirmDateChangeDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmDateChangeDialog: FC<ConfirmDateChangeDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <VyDialog
      open={open}
      onClose={onClose}
      label="Updating your contract term"
      cancelButtonText="Cancel"
      ctaText="Confirm"
      onSubmit={onConfirm}
      maxWidth="md"
    >
      <Stack sx={{
        alignItems: "right"
      }}>
        <Typography>
          <Box component="span" sx={{
            fontWeight: 600
          }}>
            Adjusting the contract start date or duration will extend any usage limits
          </Box>{' '}
          and commitment period associated with it. Any unused committed spend will be carried out through end
          date.
        </Typography>
      </Stack>
    </VyDialog>
  );
};
